module.exports = __webpack_public_path__ + "static/img/morgan-sessions-YIN4xUBaqnk-unsplash_thumb.b9d78ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/morgan-sessions-YIN4xUBaqnk-unsplash_thumb.png
// module id = RWLS
// module chunks = 4